"use client";
import Link from "next/link";
import React from "react";
import Image from "next/image";
import { useState, useEffect } from "react";
import { LuPhoneCall } from "react-icons/lu";
import { RxEnvelopeClosed } from "react-icons/rx";

export default function EventCentres() {
  const [eventCentres, setEventCentres] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventCentres = async () => {
      try {
        const response = await fetch("/api/eventcenter");
        const data = await response.json();
        if (data.success) {
          setEventCentres(data.eventCenter);
        }
      } catch (error) {
        console.error("Error fetching event centres:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEventCentres();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: 'url("/assets/img/banners/events_bg_new.webp")',
        }}
      >
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  Event Centres
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>Event Centres</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="about-section fix section-padding">
        <div className="container packagefulldetails">
          {eventCentres.map((centre, index) => (
            <div className="row mb-5" key={centre._id || index}>
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      {index % 2 === 0 ? (
                        <>
                          <div className="col-lg-5">
                            <img
                              src={centre.image}
                              alt={centre.title}
                              style={{
                                height: "300px",
                                width: "100%",
                                objectFit: "cover",
                              }}
                              className="faqbg"
                            />
                          </div>
                          <div className="col-lg-7 guestrooms">
                            <h2>{centre.title}</h2>
                            <ul className="pb-2">
                              <li>
                                <strong>Capacity :</strong> {centre.capacity}
                              </li>
                              <li>
                                <strong>Features :</strong> {centre.features}
                              </li>
                              <li>
                                <strong>Description :</strong>{" "}
                                {centre.description}
                              </li>
                              {/* <li>
                                <strong>Price :</strong> {centre.price}
                              </li> */}
                            </ul>
                            <div className="contactguestbox">
                              <div className="align-self-center">
                                <h4 className="bg-bluetxt">For Booking</h4>
                              </div>
                              <div className="d-flex">
                                <LuPhoneCall />
                                <h4>{centre.mobile}</h4>
                              </div>
                              <div className="d-flex">
                                <RxEnvelopeClosed />
                                <h4>{centre.email}</h4>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-lg-7 guestrooms order-lg-0 order-1">
                            <h2>{centre.title}</h2>
                            <ul className="pb-2">
                              <li>
                                <strong>Capacity :</strong> {centre.capacity}
                              </li>
                              <li>
                                <strong>Features :</strong> {centre.features}
                              </li>
                              <li>
                                <strong>Description :</strong>{" "}
                                {centre.description}
                              </li>
                              {/* <li>
                                <strong>Price :</strong> {centre.price}
                              </li> */}
                            </ul>
                            <div className="contactguestbox">
                              <div className="align-self-center">
                                <h4 className="bg-bluetxt">For Booking</h4>
                              </div>
                              <div className="d-flex">
                                <LuPhoneCall />
                                <h4>{centre.mobile}</h4>
                              </div>
                              <div className="d-flex">
                                <RxEnvelopeClosed />
                                <h4>{centre.email}</h4>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-5 order-lg-1 order-0">
                            <img
                              src={centre.image}
                              alt={centre.title}
                              style={{
                                height: "300px",
                                width: "100%",
                                objectFit: "cover",
                              }}
                              className="faqbg"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
